import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger, SplitText);

const headingModule = () => {

    const headings = document.querySelectorAll('.js-heading');

    headings.forEach(heading => {

        const splitText = new SplitText(heading, {
            type: "words",
            mask: "words",
        });

        const words = splitText.words;

        gsap.set(heading, { opacity: 1 });

        ScrollTrigger.matchMedia({
            "(pointer: fine)": function() {

                gsap.set(words, {
                    yPercent: 120,
                });

                words.forEach((word, index) => {

                    word.classList.add('py-4');
                    word.parentElement.classList.add('-my-4');

                    gsap.to(word, {
                        duration: 1,
                        yPercent: 0,
                        ease: 'power3.inOut',
                        delay: index * 0.02,
                        scrollTrigger: {
                            trigger: heading,
                            start: 'top 90%',
                            end: 'bottom bottom',
                        },

                    });

                });

            },
            "(pointer: coarse)": function() {

                gsap.set(words, {
                    yPercent: 0,
                });

            }
        });


    });

}

export default headingModule;